import { getCommissionProgressByCommPayType } from '../../api/commissionProgressApi';
import AccountantCommissionListWrapper from './accountantCommissionListWrapper';
import { Box } from '@mui/material';

/**
 * All MUC — every mark-up commission in the book.
 *
 * (user 2026-11-02: "can do another one which is extra markup $ as another comm?
 *  Markup Comm MUC")
 *
 * A mark-up used to be added into the agent's PSC and disappear — sale 2216's PSC of
 * RM3,653.70 is 7% of the base plus a RM1,000 mark-up, and no field recorded that the
 * 1,000 was a mark-up at all. This list is the first place it can be seen on its own.
 *
 * Agent Discount is kept in the columns on purpose: a mark-up IS a negative agent
 * discount, so that column is where the amount came from and the two should be readable
 * side by side.
 */
const MUC_COLUMNS = [
    'salesId', 'depositDate', 'customer', 'agent', 'coAgent',
    'paymentTo', 'commission', 'progress', 'custProgress', 'status',
    'productCategory', 'productEnergy',
    'asternDiscount', 'agentDiscount', 'finalPrice',
    'firstPayment', 'firstPaymentDate', 'secondPayment', 'secondPaymentDate',
    'repayment',
    'actions',
];

export default function AllMucList() {
    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>All MUC</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Markup Commission records &mdash; the agent&rsquo;s share of a price mark-up</p>
            </Box>
            <AccountantCommissionListWrapper
                apiCall={() => getCommissionProgressByCommPayType("MUC")}
                visibleColumns={MUC_COLUMNS}
            />
        </div>
    );
}
